import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Event, Information } from "../simulation/types"
import { Choice, ChoiceType, DecisionState } from "./types"

const initialState: DecisionState = {
  activeChoiceType: null,
  selectedTreeItem: null,
  addConnectionOpenFlag: false,
  activeChoice: null,
  activeChoiceConnections: [] as Event[],
  treeSearchResults: [] as number[],
  activeSearchQuery: "",
}

export const decisionsSlice = createSlice({
  name: "decisionsSlice",
  initialState,
  reducers: {
    setActiveChoiceType: (state, action: PayloadAction<ChoiceType | null>) => {
      state.activeChoiceType = action.payload
    },
    setSelectedTreeItem: (state, action: PayloadAction<Information | null>) => {
      state.selectedTreeItem = action.payload
    },
    setActiveChoice: (state, action: PayloadAction<Choice | null>) => {
      state.activeChoice = action.payload
    },
    setAddConnectionOpenFlag: (state, action: PayloadAction<boolean>) => {
      state.addConnectionOpenFlag = action.payload
    },
    setActiveChoiceConnections: (state, action: PayloadAction<Event[]>) => {
      state.activeChoiceConnections = action.payload
    },
    setTreeSearchResults: (state, action: PayloadAction<number[]>) => {
      state.treeSearchResults = action.payload
    },
    setActiveSearchQuery: (state, action: PayloadAction<string>) => {
      state.activeSearchQuery = action.payload
    },
    addActiveChoiceConnection: (state, action: PayloadAction<Event>) => {
      state.activeChoiceConnections.push(action.payload)
    },
    removeActiveChoice(state) {
      state.activeChoice = null
    },
    resetDecisions: () => {
      return initialState
    },
  },
})

export const {
  setActiveChoiceType,
  setSelectedTreeItem,
  setActiveChoice,
  setAddConnectionOpenFlag,
  setActiveChoiceConnections,
  setTreeSearchResults,
  setActiveSearchQuery,
  addActiveChoiceConnection,
  resetDecisions,
  removeActiveChoice,
} = decisionsSlice.actions

export default decisionsSlice.reducer
